module.exports = __webpack_public_path__ + "images/assets/8a2a77f360cd2fc643d63518cda69ae9.svg";